const NAMESPACE = "subsystem";

const KEYS = {
    inverterLabel: "inverterLabel",
    subsystemCloneButtonLabel: "subsystemCloneButtonLabel",
    deleteInverterButtonLabel: "deleteInverterButtonLabel",
    inverterTypeSolarOnlyLabel: "inverterTypeSolarOnlyLabel",
    inverterTypeHybridLabel: "inverterTypeHybridLabel",
    inverterTypeEssLabel: "inverterTypeEssLabel",
    solarOnlyMicroinverterDescriptor: "solarOnlyMicroinverterDescriptor",
    hybridMicroinverterDescriptor: "hybridMicroinverterDescriptor",
    inverterSmartStandardLabel: "inverterSmartStandardLabel",
    addArrayButtonLabel: "addArrayButtonLabel",
    addBatteryButtonLabel: "addBatteryButtonLabel",
    addBatteryButtonIsDisabledHelp: "addBatteryButtonIsDisabledHelp",
    inverterRequiresPVArrayErrorMessage: "inverterRequiresPVArrayErrorMessage",
    invalidBatterySelectionWarningMessage: "invalidBatterySelectionWarningMessage",
    updatedModelSuffix: "updatedModelSuffix",
    programDoesNotSupportEssInvertersMessage: "programDoesNotSupportEssInvertersMessage",
    pvSystemGroupDoesNotSupportEssInvertersMessage: "pvSystemGroupDoesNotSupportEssInvertersMessage",
    projectDoesNotMeetEssInverterConditionWarningMessage: "projectDoesNotMeetEssInverterConditionWarningMessage",
    projectDoesNotMeetStorageConditionWarningMessage: "projectDoesNotMeetStorageConditionWarningMessage"
};

const MESSAGES = {
    [KEYS.inverterLabel]: {
        value: "Inverter",
        comment: "Label for inverter section"
    },
    [KEYS.subsystemCloneButtonLabel]: {
        value: "Clone System",
        comment: "Label for button to clone an entire subsystem including its children"
    },
    [KEYS.deleteInverterButtonLabel]: {
        value: "Delete Inverter",
        comment: "Label for button to delete inverter"
    },
    [KEYS.inverterTypeSolarOnlyLabel]: {
        value: "Solar",
        comment: "Label used for Solar-Only inverters"
    },
    [KEYS.inverterTypeHybridLabel]: {
        value: "Hybrid",
        comment: "Label used for Solar/Battery Hybrid inverters"
    },
    [KEYS.inverterTypeEssLabel]: {
        value: "Energy Storage System",
        comment: "Label used for Energy Storage System inverters"
    },
    [KEYS.solarOnlyMicroinverterDescriptor]: {
        value: "Solar Microinverter",
        comment: "Label used for Solar-Only Microinverters"
    },
    [KEYS.hybridMicroinverterDescriptor]: {
        value: "Hybrid Microinverter",
        comment: "Label used for Solar/Battery Hybrid Microinverters"
    },
    [KEYS.inverterSmartStandardLabel]: {
        value: "Meets Standard:",
        comment:
            "Label for the highest smart inverter standard met by the chosen inverter model. Shown next to the inverter rating."
    },
    [KEYS.addArrayButtonLabel]: {
        value: "Add Array",
        comment: "Label for button to add arrays"
    },
    [KEYS.addBatteryButtonLabel]: {
        value: "Add Battery",
        comment: "Label for button to add battery"
    },
    [KEYS.addBatteryButtonIsDisabledHelp]: {
        value: "Batteries can only be attached to hybrid inverters or energy storage systems.",
        comment:
            "Help text displayed when the Add Battery button is disabled due to a Solar-Only inverter being selected"
    },
    [KEYS.inverterRequiresPVArrayErrorMessage]: {
        value: "This inverter must have at least one PV Array defined.",
        comment: "Error message displayed when an inverter does not have any PV arrays defined."
    },
    [KEYS.invalidBatterySelectionWarningMessage]: {
        value: "Batteries can only be attached to hybrid inverters or energy storage systems. Please remove the battery or update the inverter to a model that supports batteries.",
        comment: "Warning message displayed when a battery has been defined for a Solar-Only inverter"
    },
    [KEYS.updatedModelSuffix]: {
        value: " - UPDATED",
        comment: "Suffix to use on a model definition which is an updated version of the stored model"
    },
    [KEYS.programDoesNotSupportEssInvertersMessage]: {
        value: "This program does not support the selection of ESS inverters.",
        comment: "Error message displayed when an ESS inverter is selected in a program that does not support it."
    },
    [KEYS.pvSystemGroupDoesNotSupportEssInvertersMessage]: {
        value: "This PV System data field group does not support the selection of ESS inverters.",
        comment:
            "Error message displayed when an ESS inverter is selected for a PV System group that does not support it."
    },
    [KEYS.projectDoesNotMeetEssInverterConditionWarningMessage]: {
        value: "This project does not meet the conditions required for the selection of ESS inverters.",
        comment:
            "Warning message displayed when an ESS inverter is selected for a project that does not meet the prescribed conditions."
    },
    [KEYS.projectDoesNotMeetStorageConditionWarningMessage]: {
        value: "This project does not meet the conditions required for including storage equipment.",
        comment:
            "Warning message displayed when storage equipment is selected for a project that does not meet the prescribed conditions."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
